import Utils from '../../../../common/js/Utils';
import AnchorLinks from './AnchorLinks';

const buttonClickEventHandler = event => {
    event.preventDefault();

    window.location.href = event.currentTarget.dataset.href
};

export default class Menu {

    static initializeEvents() {
        this.markCurrentItemAsActive();
        this.collapseMenuItems();

        window.addEventListener('resize', this.collapseMenuItems);

        Array
            .from(document.querySelectorAll('.menu .navigation-dropdown-button, .menu .navigation-section-button'))
            .forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();

                    const dropdown = event.currentTarget.parentNode.querySelector('.navigation-dropdown, .navigation-section');
                    if (dropdown) {
                        this.closeAllDropdowns(dropdown);
                        dropdown.classList.toggle('active');

                        // update icon (folded / unfolded)
                        const icon = event.currentTarget.parentNode.querySelector('i[class^=ri-]');
                        if (icon) {
                            this.toggleArrowIcon(icon);
                        }
                    }
                });
            });

        Array
            .from(document.querySelectorAll('.menu .navigation-dropdown a[href*="#"], .menu .navigation-section a[href*="#"]'))
            .forEach(link => {
                link.addEventListener('click', event => {
                    const dropdown = Utils.parent(event.currentTarget, '.navigation-dropdown, .navigation-section');
                    if (dropdown) {
                        this.closeAllDropdowns(dropdown);
                        dropdown.classList.toggle('active');

                        // update icon (folded / unfolded)
                        const icon = dropdown.parentNode.querySelector('i[class^=ri-]:first-child');
                        if (icon) {
                            this.toggleArrowIcon(icon);
                        }
                    }

                    const menu = document.getElementById('menu-main');
                    menu.classList.remove('active');

                    const urlString = link.getAttribute('href');
                    const url = new URL(urlString, window.location.origin);
                    AnchorLinks.adjustScrollForAnchor(url, event);
                });
            });

        // Open or close main & search menus
        Array
            .from(document.querySelectorAll('.menu-button, .menu-search'))
            .forEach(menuButton => menuButton.addEventListener('click', event => {
                menuButton.classList.toggle('section');
                menuButton.classList.toggle('secondary');

                const targetMenu = document.getElementById(event.currentTarget.dataset.target);
                targetMenu.classList.toggle('active');

                // Close other menus
                Array
                    .from(document.querySelectorAll('.menu-button, .menu-search'))
                    .forEach(otherMenuButton => {
                        if (event.currentTarget.dataset.target !== otherMenuButton.dataset.target) {
                            otherMenuButton.classList.remove('section', 'secondary');

                            const otherTargetMenu = document.getElementById(otherMenuButton.dataset.target);
                            otherTargetMenu.classList.remove('active');
                        }
                    });
            }));

        // When you click on the site's main content (so excluding the header and footer), you close any open menus.
        const main = document.querySelector('main[role="main"]');
        if (main) {
            main.addEventListener('click', () => {
                Array
                    .from(document.querySelectorAll('.menu.active'))
                    .forEach(menu => menu.classList.remove('active'));
                this.closeAllDropdowns();
            });
        }

        // Pour l'impression, tous le menu sont invisible
        window.addEventListener('beforeprint', () => {
            Array
                .from(document.querySelectorAll('#menu-main'))
                .forEach(menu => {
                    menu.style.display = 'none';
                });
        });
    }

    static collapseMenuItems() {
        if (window.innerWidth >= 768 && window.innerWidth < 1248) {
            Array
                .from(document.querySelectorAll('.menu .menu-item-section-collapsable > a, .menu .menu-item-section-collapsable > button'))
                .forEach(button => {
                    const buttonIndex = Array.from(button.parentNode.parentNode.children).indexOf(button.parentNode);
                    if (buttonIndex < (window.innerWidth >= 992 ? 4 : 3)) {
                        return;
                    }

                    let menuOtherItemsElement = button.parentNode.parentNode.querySelector('.menu-other-items');
                    if (menuOtherItemsElement === null && !button.parentNode.parentElement.classList.contains('menu-other-items')) {
                        menuOtherItemsElement = document.createElement('ul');
                        menuOtherItemsElement.classList.add('menu-other-items');

                        const menuOtherItemsButtonElement = document.createElement('button');
                        menuOtherItemsButtonElement.classList.add('menu-other-items-button', 'btn', 'tertiary');
                        menuOtherItemsButtonElement.innerHTML = '<i class="ri-arrow-right-double-line ri-lg mr-0" aria-hidden="true"></i>';
                        menuOtherItemsButtonElement.addEventListener('click', event => {
                            menuOtherItemsElement.classList.toggle('active');

                            // Icon rotation
                            event.currentTarget.firstChild.classList.toggle('ri-arrow-right-double-line');
                            event.currentTarget.firstChild.classList.toggle('ri-close-line');

                            // TODO: optimize
                            if (this.name ?? '' === 'Menu') {
                                this.closeAllDropdowns();
                            }
                        });

                        button.parentNode.parentNode.appendChild(menuOtherItemsButtonElement);
                        button.parentNode.parentNode.appendChild(menuOtherItemsElement);
                    }

                    if (menuOtherItemsElement !== null) {
                        button.classList.remove('navigation-section-button');
                        button.role = 'link';
                        button.setAttribute('href', button.dataset.href);
                        button.onclick = buttonClickEventHandler;

                        menuOtherItemsElement.appendChild(button.parentNode);
                    }
                });
        } else {
            const menuOtherItemsButtonElement = document.querySelector('.menu-other-items-button');
            if (menuOtherItemsButtonElement) {
                menuOtherItemsButtonElement.parentNode.removeChild(menuOtherItemsButtonElement);
            }

            const menuOtherItemsElement = document.querySelector('.menu-other-items');
            if (menuOtherItemsElement) {
                const nonCollapsableMenuItems = document.querySelectorAll('.menu .menu-item-section:not(.menu-item-section-collapsable), .menu .menu-item-section:not(.menu-item-section-collapsable)');
                const firstNonCollapsableMenuItem = nonCollapsableMenuItems[nonCollapsableMenuItems.length - 1];

                Array.from(menuOtherItemsElement.children).forEach(menuItem => {
                    const menuItemButton = menuItem.querySelector('a, button');

                    menuItemButton.classList.add('navigation-section-button');
                    menuItemButton.role = 'button';
                    menuItemButton.removeAttribute('href');
                    menuItemButton.removeEventListener('click', buttonClickEventHandler);

                    firstNonCollapsableMenuItem.parentNode.insertBefore(menuItem, firstNonCollapsableMenuItem);
                });

                menuOtherItemsElement.parentNode.removeChild(menuOtherItemsElement);
            }
        }
    }

    static markCurrentItemAsActive() {
        Array
            .from(document.querySelectorAll('.menu ul[data-menu-current-location-path]'))
            .forEach(menuListElement => {
                const currentLocationPath = menuListElement
                    .getAttribute('data-menu-current-location-path')
                    .split('/')
                    .filter(id => id.length >= 2);

                let searchProduct = menuListElement.getAttribute('data-url-search-product-publication-tag');

                if (searchProduct) {
                        const labelSearch = {
                            'Domaines'    : 'domaines',
                            'Collections' : 'collections'
                        };

                        searchProduct = searchProduct.split('|');

                        Array
                            .from(menuListElement.querySelectorAll('button'))
                            .forEach(itemElement => {
                                if (searchProduct[0] === labelSearch[itemElement.textContent.trim()] ) {
                                    itemElement.parentElement.classList.add('active');
                                    Array
                                        .from(itemElement.parentElement.querySelectorAll('ul li a'))
                                        .forEach( itemLinkElement => {
                                            if (itemLinkElement.href.split('/').at(-1) === searchProduct[1]) {
                                                itemLinkElement.parentElement.classList.add('active');
                                                itemLinkElement.setAttribute('aria-current', 'page');
                                                itemLinkElement.setAttribute('aria-label', itemLinkElement.innerText.trim() + ' (page active)');
                                            }
                                        })
                                }
                            });
                } else {
                    currentLocationPath.forEach((id, index) => {
                        const itemElement = menuListElement.querySelector('[data-menu-location-id="' + id + '"]');
                        if (itemElement) {
                            itemElement.classList.add('active');

                            // Last element
                            if (index === (currentLocationPath.length - 1)) {
                                const itemLinkElement = itemElement.querySelector('a');
                                if (itemLinkElement) {
                                    itemLinkElement.setAttribute('aria-current', 'page');
                                    itemLinkElement.setAttribute('aria-label', itemLinkElement.innerText.trim() + ' (page active)');
                                }
                            }
                        }
                    });
                }
            });
    }

    static closeAllDropdowns(exception = null) {
        const parentDropdown = exception !== null ? Utils.parent(exception, '.navigation-dropdown.active, .navigation-section.active') : null;
        const dropdownsWrapper = parentDropdown !== null ? parentDropdown : document;

        Array
            .from(dropdownsWrapper.querySelectorAll('.menu .navigation-dropdown.active, .menu .navigation-section.active'))
            .forEach(dropdown => {
                if (exception !== dropdown) {
                    dropdown.classList.remove('active');

                    // update icon (folded / unfolded)
                    const icon = dropdown.parentNode.querySelector('i[class^=ri-]');
                    if (icon) {
                        this.toggleArrowIcon(icon);
                    }
                }
            });
    }

    static toggleArrowIcon(icon) {
        if (icon.classList.contains('ri-arrow-up-s-line') || icon.classList.contains('ri-arrow-down-s-line')) {
            icon.classList.toggle('ri-arrow-up-s-line');
            icon.classList.toggle('ri-arrow-down-s-line');
        }

        if (icon.classList.contains('ri-arrow-left-s-line') || icon.classList.contains('ri-arrow-right-s-line')) {
            icon.classList.toggle('ri-arrow-left-s-line');
            icon.classList.toggle('ri-arrow-right-s-line');
        }
    }

}
